/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;'use strict';
	
	/**
	 * pharmacyselfservice.js: Feature level module
	 * @description This module is used for : 
	 * 										1. Displaying Marketing Content
	 */
	
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
		if (typeof window.COSTCO == 'undefined') {
			window.COSTCO = new Object();
		}
	
		var PharmacySelfService = {
	
			/** createCMPPCarousels used for created the carousels - desktop and mobile - displaying product tiles new to CMPP 
	  		 * NOTE: The creation of two carousels for desktop and mobile
	  		*/
			createCMPPCarousels: function createCMPPCarousels() {
				$('#new-to-cmpp').show();
				//Desktop view
				COSTCO.util.carousel('#new-to-cmpp-products-carousel-desktop', {
					dots: true,
					arrows: true,
					prevArrow: '<button id="cmppPrevArrowDesktop" class="slick-prev" aria-label="Previous" type="button">Previous</button>',
					nextArrow: '<button id="cmppNextArrowDesktop" class="slick-next" aria-label="Next" type="button">Next</button>',
					moveArrowstoDots: true,
					slidesToShow: 4,
					slidesToScroll: 4,
					autoplay: false,
					infinite: false,
					lazyLoad: 'ondemand',
					owlDotLabel: messages.CMPP_NEW_PRODUCTS
				}, { nextLabel: messages.CMPP_CAROUSEL_NEXT, prevLabel: messages.CMPP_CAROUSEL_PREVIOUS });
				//Mobile view
				COSTCO.util.carousel('#new-to-cmpp-products-carousel-mobile', {
					dots: true,
					arrows: true,
					prevArrow: '<button id="cmppPrevArrowMobile" class="slick-prev" aria-label="Previous" type="button">Previous</button>',
					nextArrow: '<button id="cmppNextArrowMobile" class="slick-next" aria-label="Next" type="button">Next</button>',
					moveArrowstoDots: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					rows: 2,
					autoplay: false,
					infinite: false,
					lazyLoad: 'ondemand',
					owlDotLabel: messages.CMPP_NEW_PRODUCTS
				}, { nextLabel: messages.CMPP_CAROUSEL_NEXT, prevLabel: messages.CMPP_CAROUSEL_PREVIOUS });
				PharmacySelfService.moveIndicators();
			},
			/** moveArrowstoIndicators used for moving the carousel arrows - created from the 
	   * carousel slick.js initialisation from function 'createCMPPCarousels' - to element where the dot
	   * indicators hold in order to present the arrows in the same area as the indicators as requested by business*/
			moveIndicators: function moveIndicators() {
				// Desktop view
				$('#new-to-cmpp-products-carousel-desktop>ul.slick-dots').appendTo('#cmpp-carousel-indicators-desktop');
				$('#cmppPrevArrowDesktop').prependTo($('#cmpp-carousel-indicators-desktop'));
				$('#cmppNextArrowDesktop').appendTo($('#cmpp-carousel-indicators-desktop'));
				// Mobile view
				$('#new-to-cmpp-products-carousel-mobile>ul.slick-dots').appendTo('#cmpp-carousel-indicators-mobile');
				$('#cmppPrevArrowMobile').prependTo($('#cmpp-carousel-indicators-mobile'));
				$('#cmppNextArrowMobile').appendTo($('#cmpp-carousel-indicators-mobile'));
			},
	
			/**
	   * Get the description of the drug - used to populate the strengthDescription inside the CMPP carousel tiles
	   */
			getDrugPackageFormDescription: function getDrugPackageFormDescription(showPackageIndicatorParam, drugPackageParam, drugFormParam, drugStrengthParam, drugQuantityParam, substitutionBrandDrugs) {
				/**
	    * drugPackageOrFormParam is the string being built upon that will populate the 'strengthDescription' of the 
	    * drug tile inside the CMPP carousel. Goes through series of checks to determine what gets added to the string.
	    * At the end of the function, drugPackageOrFormParam is returned.
	    */
				var drugPackageOrFormParam = '';
				// if drug is generic version of particular drug, add the label 'Generic of' to the string describing the brand it substitutes
				if (substitutionBrandDrugs != null || substitutionBrandDrugs != undefined) {
					var genericBrandStr = 'Generic of ';
					for (var i = 0; i < substitutionBrandDrugs.length; i++) {
						genericBrandStr += substitutionBrandDrugs[i] + ', ';
					}
					drugPackageOrFormParam += genericBrandStr;
				}
				/**
	    * 'showPackageIndicatorParam' is boolean used to check if adding the package to the description is appropriate
	    * otherwise, skip appending the package description to the string
	    */
				if (showPackageIndicatorParam) {
					if (drugFormParam != 'Miscellaneous') {
						drugPackageOrFormParam += drugFormParam + ", ";
					}
					drugPackageOrFormParam += drugPackageParam;
					if ($.trim(drugStrengthParam) != '') {
						drugPackageOrFormParam += ", " + drugStrengthParam;
					}
				} else {
					if ($.trim(drugStrengthParam) != '') {
						drugPackageOrFormParam += drugStrengthParam + ", ";
					}
					drugPackageOrFormParam += drugQuantityParam + " " + drugFormParam.toLowerCase();
					if ((drugFormParam == 'Tablet' || drugFormParam == 'Capsule') && drugQuantityParam > 1) {
						drugPackageOrFormParam += "s";
					}
				}
				/**
	    * return 'drugPackageOrFormParam' to be used to populate 'strengthDescription'
	    * inside drug tile template 'tmpl_new_to_cmpp_carousel_product_display'
	    */
				return drugPackageOrFormParam;
			},
	
			/**
	   * getFormularyPetMedicationsProductsById is a method is used for displaying formulary products for the Pet Medications.
	   * This method is invoke by the primary method getFormularyPetSavingsDrugAuthDetails
	   * @param : formularyId
	   */
			getFormularyPetMedicationsProductsById: function getFormularyPetMedicationsProductsById(data) {
				var remark_html = '';
				var object = data;
				remark_html += COSTCO.util.tmpl('tmpl_drug_pet_formulary_details_heading', {});
				for (var i in object.items) {
					var drugStrengthStr = !/^ *$/.test(object.items[i].drugAndStrength) ? " - " + object.items[i].drugAndStrength : "";
					remark_html += COSTCO.util.tmpl('templ_formulary_pet_medications_products_display', {
						drugName: object.items[i].drugName,
						dosageForm: object.items[i].dosageForm,
						quantity: object.items[i].quantity,
						drugAndStrength: drugStrengthStr,
						drugPrice: PharmacySelfService.populateMinumumPrice(object.items[i])
					});
				}
				remark_html = remark_html + '</table>';
				$('#div_formulary_pet_medications_products_display').html(remark_html);
			},
	
			/**
	   * populateMinumumPrice is a method is used for return the minimum price from the list of prices.
	   * @param : JSON object
	   */
			populateMinumumPrice: function populateMinumumPrice(object) {
				var priceListarr = [];
				var minPrice = null;
				object.networkPriceInfo.forEach(function (storeObj, i) {
					priceListarr.push(storeObj.cmppPrice);
				});
				minPrice = Math.min.apply(null, priceListarr);
				return minPrice;
			}
		};
		window.COSTCO.PharmacySelfService = PharmacySelfService;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }
/******/ ]);


// WEBPACK FOOTER //
// pharmacyselfservice.module.min.js